module.exports = __webpack_public_path__ + "static/media/fruits_29.eb5b1dc4.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_29.csv
// module id = 694
// module chunks = 0